import { WelcomePage } from '@/features/onboarding';

export default function WelcomeRoute() {
  return <WelcomePage />;
}
